import type { Novidade } from './tipos';

/**
 * Fase 2, W14 (novidade na W17): lixeira de 30 dias (W14, mais Compras e Conversas na W16), importadores com modelo e,
 * no Contas, renegociação, baixa em lote pela lista, rateio por centro de custo e estorno da perda.
 */
export const novidadeLixeira: Novidade = {
  id: '2026-10-05-lixeira',
  publicada_em: '2026-10-05',
  tipo: 'melhoria',
  modulo: null,
  permissao: null,
  rota: '/conta/lixeira',
  textos: {
    pt: {
      titulo: 'Lixeira de 30 dias, importadores e renegociação no Contas',
      resumo: 'O que foi excluído volta em até 30 dias, as importações têm modelo e prévia, e o Contas renegocia e baixa em lote.',
      passos: [
        'Nas telas de cadastro, Compras e Conversas, o botão Lixeira mostra o que saiu nos últimos 30 dias, com quem excluiu e quando.',
        'Desfazer exclusão volta o registro como estava. Em Minha conta, Lixeira, ficam todos os módulos que você acessa.',
        'Pessoas e empresas, títulos, categorias e centros de custo importam por planilha, com modelo, prévia e o que já tinha entrado.',
        'Em A receber e A pagar, selecione títulos do mesmo parceiro para Renegociar em parcelas ou Baixar selecionados de uma vez.',
        'Na emissão, o rateio divide o título entre centros de custo; a perda registrada pode ser estornada.',
      ],
    },
    en: {
      titulo: '30-day trash, importers and renegotiation in Accounts',
      resumo: 'Deleted records come back within 30 days, imports have a template and preview, and Accounts renegotiates and settles in bulk.',
      passos: [
        'On the record screens, Purchasing and Conversations, the Trash button shows what was removed in the last 30 days, by whom and when.',
        'Undo deletion brings the record back as it was. In My account, Trash, you see every module you can access.',
        'People and companies, documents, categories and cost centers import from a spreadsheet, with template, preview and what was already in.',
        'In Receivable and Payable, select documents of the same partner to Renegotiate in installments or Settle selected at once.',
        'When issuing, the allocation splits the document between cost centers; a recorded write-off can be reversed.',
      ],
    },
    es: {
      titulo: 'Papelera de 30 días, importadores y renegociación en Cuentas',
      resumo: 'Lo borrado vuelve en hasta 30 días, las importaciones tienen plantilla y vista previa, y Cuentas renegocia y cobra en lote.',
      passos: [
        'En las pantallas de registros, Compras y Conversaciones, el botón Papelera muestra lo que salió en los últimos 30 días, con quién y cuándo.',
        'Deshacer el borrado vuelve el registro como estaba. En Mi cuenta, Papelera, están todos los módulos a los que accedes.',
        'Personas y empresas, documentos, categorías y centros de costo se importan por planilla, con plantilla, vista previa y lo que ya había entrado.',
        'En Por cobrar y Por pagar, selecciona documentos del mismo socio para Renegociar en cuotas o Pagar seleccionados de una vez.',
        'En la emisión, el prorrateo divide el documento entre centros de costo; la pérdida registrada se puede revertir.',
      ],
    },
  },
  imagens: ['/novidades/2026-10-05-lixeira/lixeira.webp', null, null, '/novidades/2026-10-05-lixeira/renegociar.webp', null],
  treinamento: { curso: 'novidades' },
};
